import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconLegal = (props) => {
  props = Object.assign({viewBox: '0 0 36 36'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <g>
          <g>
            <path d="M22.3,8.8h-6.1V10h6.1V8.8L22.3,8.8z M11.3,12.7v1.2h11v-1.2H11.3z M11.3,17.6h11v-1.2h-11V17.6L11.3,17.6z
				 M11.3,21.3h11v-1.2h-11V21.3L11.3,21.3z M11.3,25h11v-1.2h-11V25L11.3,25z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M10.9,32.4h18v-1.2h-18V32.4L10.9,32.4z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M29.8,32.4l0-27h-1.2l0,27H29.8L29.8,32.4z"/>
          </g>
        </g>
        <path d="M27.4,30.2H6.2V3.6h21.1L27.4,30.2L27.4,30.2z M7.5,28.9h18.6v-24H7.5V28.9z"/>
      </g>
    </SvgIcon>
  );
};

IconLegal.displayName = 'IconLegal';
IconLegal.muiName = 'SvgIcon';

export default IconLegal;



// WEBPACK FOOTER //
// ./src/components/Icons/IconLegal.js